import React, { useEffect, useState } from 'react'
import { Button, Skeleton, Spinner, image } from '@nextui-org/react'
import { TfiLayoutGrid2Alt, TfiLayoutGrid3Alt, TfiLayoutGrid4Alt } from "react-icons/tfi";
import {Accordion, AccordionItem} from "@nextui-org/react";
import {Checkbox} from "@nextui-org/react";
import {Slider} from "@nextui-org/slider";
import {Dropdown, DropdownTrigger, DropdownMenu, DropdownItem} from "@nextui-org/react";
import { BiFilterAlt } from "react-icons/bi";
import { PiSortAscendingBold } from "react-icons/pi";
import { FaUsers } from "react-icons/fa";
import { MdOutlineBookmarkBorder } from "react-icons/md";
import { MdOutlineAccessTime } from "react-icons/md";
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import {RadioGroup, Radio, useRadio, VisuallyHidden, cn} from "@nextui-org/react";
import { getCourseList, getFilterCourseList, getLevelList } from '../actions/courseActions';
import { useDispatch, useSelector } from 'react-redux';
import { all } from 'axios';
import {Tabs, Tab} from "@nextui-org/react";
import { VscActivateBreakpoints } from "react-icons/vsc";
import _ from 'lodash';

const CourseFilterScreen = () => {
  const [filter, setFilter] = useState(false);
  const [gridCount, setGridCount] = useState(2); 

  const {faculty} = useParams()
  const {programe} = useParams()
  const {qualification} = useParams()
  const {credit} = useParams()

  const dispatch = useDispatch()
  const history = useNavigate()
  const location = useLocation()

  const [nFaculty, setNFaculty] = useState(faculty?faculty:'faculties')
  const [n2Faculty, setN2Faculty] = useState(null)
  const [nPrograme, setNPrograme] = useState(programe?programe:'programes')
  const [nQualification, setNQualification] = useState(qualification?qualification:'qualifications')
  const [nCredits, setNCredits] = useState(credit?credit:'credits')
  const [nCourses, setNCourses] = useState(null)

  useEffect(() => {
    if(faculty){
      setNFaculty(faculty)
    } else{
      setNFaculty('faculties')
    }
    if(programe){
      setNPrograme(programe)
    }else{
      setNPrograme('programes')
    }

    if(qualification){
      setNQualification(qualification)
    }else{
      setNQualification('qualifications')
    }
 
    if(credit){
      setNCredits(credit)
    }else{
      setNCredits('credits')
    }
  }, [faculty, programe, qualification, credit])
  
 
  const levelList = useSelector(state => state.levelList)
  const { error, loading, levels } = levelList

  const courseList = useSelector(state => state.courseList)
  const { error: courseListError, loading: courseListLoading, courses } = courseList

  const courseFilterList = useSelector(state => state.courseFilterList)
  const { error: courseFilterListError, loading: courseFilterListLoading, courses:fCourses } = courseFilterList

  const facultyList = useSelector(state => state.facultyList)
  const { error: facultyListError, loading:facultyListLoading, faculties } = facultyList
  
  useEffect(() => {
    if(!levels){
      dispatch(getLevelList())
    }
    if(courses==null){
      dispatch(getCourseList())
    }
    if(n2Faculty){
      setNFaculty(n2Faculty.anchorKey)
    }
  }, [dispatch, levels, courses, n2Faculty])

  
  // useEffect(() => {
  //   if (faculty) {
  //     setNFaculty(faculty)
  //   } else {
  //     setNFaculty('faculties')
  //   }
  //   if (programe) {
  //     setNPrograme(programe)
  //   } else {
  //     setNPrograme('programes')
  //   }    
  //   if (qualification) {
  //     setNQualification(qualification)
  //   } else{
  //     setNQualification('qualifications')
  //   }
  //   if (credit) {
  //     setNCredits(credit)
  //   }  else{
  //     setNCredits('credits')
  //   }
  // }, [faculty,programe, qualification, credit])

  useEffect(() => {
    dispatch(getFilterCourseList(nFaculty, nPrograme, nQualification, nCredits))
  }, [dispatch, nFaculty, nPrograme, nQualification, nCredits, location])

  
  // useEffect(() => {
  //   if ((courses) && (nPrograme) && (nFaculty)) {
  //     setNCourses(courses.filter(f=> f.faculty.slug == nFaculty.anchorKey && f.programme.slug == nPrograme))
  //   } else if ((courses) && (nPrograme)) {
  //     setNCourses(courses.filter(f=> f.programme.slug == nPrograme))
  //   } else{
  //     setNCourses(courses)
  //   }
  // }, [courses, nFaculty, nPrograme])

  // useEffect(() => {
  //   setNCourses(courses.filter(f=> nFaculty.anchorKey? f.faculty.slug == nFaculty.anchorKey : courses))
  // }, [courses, nPrograme])
  

  useEffect(() => {
    window.scroll(0,0);
  }, [location]);

  return (
    <div className='h-fit w-full relative pb-12'>
      {/* <div className='relative h-fit w-full md:hidden '>
        <div className='h-fit w-full max-w-[1200px] mx-auto px-4 sm:px-6 overflow-hidden'>
          <div className='flex items-center justify-between my-2 font-medium border-2 mt-28 md:mt-0'>
            <div className='max-h-fit flex divide-x-1 overflow-hidden'>
              <Button onClick={() => setFilter(!filter)} endContent={<BiFilterAlt className='text-xl' />} variant='bordered' radius='none' className='text-xs border-0 ' size='sm'>Filter</Button>
              <Dropdown>
                <DropdownTrigger>
                <Button endContent={<PiSortAscendingBold className='text-xl'/>} variant='bordered' radius='none' className='text-xs border-0 ' size='sm'>Sort</Button>
                </DropdownTrigger>
                <DropdownMenu aria-label="Static Actions">
                  <DropdownItem key="new">New file</DropdownItem>
                  <DropdownItem key="copy">Copy link</DropdownItem>
                  <DropdownItem key="edit">Edit file</DropdownItem>
                  <DropdownItem key="delete" className="text-danger" color="danger">
                    Delete file
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown> 
              <div className='h-[40px] w-[1px] border-l-2'></div> 
            </div>
            <div className='flex items-center px-2'>
              <Button onClick={() => setGridCount(1) } isIconOnly size='sm' variant='light'>
                <div className='h-[14px] w-[14px] bg-black md:hidden'></div>
              </Button>
              <Button onClick={() => setGridCount(2) } isIconOnly size='sm' variant='light'>
                <TfiLayoutGrid2Alt className='text-[14px] mt-[2px]' />
              </Button>
              <Button onClick={() => setGridCount(3) } isIconOnly size='sm' variant='light' className='hidden md:flex'>
                <TfiLayoutGrid3Alt className='text-[14px]' />
              </Button>
              <Button onClick={() => setGridCount(4) } isIconOnly size='sm' variant='light' className='hidden xl:flex'>
                <TfiLayoutGrid4Alt className='text-[15px] ' />
              </Button>
            </div>
          </div>
        </div>
      </div> */}
      <div className='h-fit w-full max-w-[1024px] mx-auto  flex gap-4 md:px-6 pt-4'>

        <div className='h-fit w-full flex flex-col gap-6 relative z-10'>
        
          <div className={`w-full mx-auto h-fit grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2 md:gap-4 px-4 md:px-0`}>
          {
            courseFilterListLoading
              ? <div className='h-fit w-full flex justify-start'>
                  <Spinner size="md" />
                </div>
              : fCourses
                ? fCourses
                    .filter(course => course.qualification? course.qualification.slug !== 'othm-uk-qualification' : course) // Filter out courses with specific qualification slug
                    .map(course => (
                      <div key={course.slug} className='bg-white mt-[24px] mb-[48px]'>
                        <Link to={`/courses/${course.slug}`} className='flex flex-col min-w-full gap-2 shadow-md'>
                          <div className='h-[150px] w-full overflow-hidden'>
                            <img src={course.image} alt='' className='h-[150px] hover:scale-105 duration-200 w-full object-cover border-[1px]' />
                          </div>
                          <div className='flex flex-col py-2 gap-2 p-4'>
                            <p className='font-bold capitalize'>{course.name}</p>
                          </div>
                          <div className='h-[2px] w-full px-4'>
                            <div className='h-[1px] w-full bg-gray-200'></div>
                          </div>
                          <div className='flex flex-wrap gap-1 p-4'>
                            <div className='flex text-xs text-gray-500 px-2 md:px-5 py-2 md:py-2 bg-gray-200 capitalize'>
                              online
                            </div>
                            <div className='flex text-xs text-gray-500 px-2 md:px-5 py-2 md:py-2 bg-gray-200 capitalize'>
                              {course.duration}
                            </div>
                          </div>
                        </Link>
                      </div>
                    ))
                : ''
          }
          </div>
        </div>
      </div>
    </div>
  )
}

export default CourseFilterScreen